/** Reported when the user record carries no country, so the attribute is never blank. */
export const UNKNOWN_COUNTRY_CODE = 'N/A';
